import React, { useState, useEffect } from "react";
import map from "lodash/map";
// import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
// import FormattedMessage from "components/FormattedMessage";
import { Flex, Text } from "ui-components";
import { compactJoin, sanitizeHTML } from "utils/helpers";
// import { COLORS } from "ui-components/theme";

const PromoCodeBox = props => {
  const {
    defaultValue,
    // reason,
    title,
    benefits,
    // themeColors,
    hideBenefits,
    planDetails
  } = props;

  const [value, setValue] = useState(defaultValue);
  const { name } = planDetails
  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  // const errorReason = reason && `promo_code.${reason.toLowerCase()}`;
  // const errorColor = get(themeColors, "error", COLORS.red[2]);

  // This is for order placement and activation 
  const promoBenefits = !isEmpty(benefits)
    ? compactJoin(map(benefits, "title"), "<br/>")
    : "";

  const promoDetails =
    !hideBenefits && promoBenefits
      ? compactJoin(
          [
            "<div style='font-weight: bold'>",
            "</div><br/><br/>",
            title
          ],
          ""
        )
      : title;

  return (
    <>
      {value && promoDetails && (
        <Flex
          flexDirection="column"
          alignItems="flex-start"
          width="100%"
          p="3"
          backgroundColor="#EEF9F8"
          sx={{
            borderRadius: "20px",
            // Reset margin & padding on injected HTML tags to match Figma line height
          }}
        >
          {name && (
            <Text
              fontSize="13.3px"
              fontWeight="700"
              color="#0f172a"
              sx={{
                margin:0,
              }}
            >
              {name}
            </Text>
          )}
          <Text
            width="100%"
            fontSize="14px"
            color="#0f172a"
            sx={{ marginLeft:'10px'}}
            dangerouslySetInnerHTML={{ __html: sanitizeHTML(promoDetails) }}
          />
        </Flex>
      )}

      {/* {value && errorReason && (
        <FormattedMessage id={errorReason}>
          {errorMsg => (
            <Text fontWeight="500" my={1} size="xs" color={errorColor}>
              {errorMsg}
            </Text>
          )}
        </FormattedMessage>
      )} */}
    </>
  );
};

PromoCodeBox.defaultProps = {
  title: "",
  defaultValue: "",
  defaultPromoCodeOffers: []
};

export default PromoCodeBox;
